
import escape from 'lodash/escape'
import Vue from 'vue'
import ResultTriangle from '~/components/atoms/ResultTriangle.vue'
import ResultList from '~/components/molecules/ResultList.vue'
import ResultSummaryCard from '~/components/organisms/ResultSummaryCard.vue'
import ResultDetailCard from '~/components/organisms/ResultDetailCard.vue'
import Button from '~/components/atoms/Button.vue'
import FloatBar from '~/components/atoms/FloatBar.vue'
import Card from '~/components/atoms/Card.vue'
// import { DiagnosisApiUrl } from '~/server/api/route/url'
import { Result } from '~/types/api/result'
import RecommendCard from '~/components/organisms/RecommendCard.vue'
import { SERVICES } from '~/consts/recommend'

// import * as canvasHelper from '~/helpers/canvasHelper/canvasHelper'

const ogpUrl = `${process.env.JOBRAINBOW_STATIC_PATH}/sexuality/:diagnosisId/ogp.png`

export default Vue.extend({
  components: {
    Button,
    FloatBar,
    ResultTriangle,
    ResultList,
    ResultSummaryCard,
    ResultDetailCard,
    Card,
    RecommendCard,
  },
  layout: 'public',
  async asyncData({ $axios, route }) {
    if (!route.params.diagnosisId) {
      return
    }
    const resultUrl = process.browser
      ? '/staticapi/sexuality/:diagnosisId/result.json'
      : `${process.env.JOBRAINBOW_STATIC_PATH}/sexuality/:diagnosisId/result.json`
    // const resultUrl = `/staticapi/sexuality/:diagnosisId/result.json`
    const result: Result = await $axios.$get(resultUrl.replace(':diagnosisId', route.params.diagnosisId))
    return { result }
  },
  data() {
    return {
      services: SERVICES.filter((service) => service.name === 'jobrainbow'),
    }
  },
  head() {
    return {
      // title: this.$data.qa.answer.answererNickname,
      meta: [
        { name: 'robots', content: 'noindex' },
        { hid: 'og:type', property: 'og:type', content: 'article' },
        { hid: 'og:title', property: 'og:title', content: `この人のセクシュアリティ診断結果と用語解説を見る` },
        { hid: 'og:url', property: 'og:url', content: `${process.env.CLIENT_BASE_URL}/diagnoses/${escape(this.$route.params.diagnosisId as string)}/share` },
        { hid: 'og:image', property: 'og:image', content: ogpUrl.replace(':diagnosisId', escape(this.$route.params.diagnosisId as string)) },
        { hid: 'twitter:card', property: 'twitter:card', content: 'summary_large_image' },
        { hid: 'og:description', property: 'og:description', content: '5分で完了する無料の診断で、貴方のセクシュアリティ（性のあり方）が詳しくわかります。' },
      ],
    }
  },
  methods: {
    start() {
      const URL = '/auth/register'
      this.$router.push(URL)
    },
    goTop() {
      this.$router.push('/')
    },
  },
})
